import newFlightMarkerDefault from "../../../../assests/map-markers/newFlightMarkerDefault.svg";
import newFlightMarkerDefaultSelected from "../../../../assests/map-markers/newFlightMarkerDefaultSelected.svg";
import newFlightMarkerDelayed from "../../../../assests/map-markers/newFlightMarkerDelayed.svg";
import newFlightMarkerDelayedSelected from "../../../../assests/map-markers/newFlightMarkerDelayedSelected.svg";
import newFlightMarkerOnTime from "../../../../assests/map-markers/newFlightMarkerOnTime.svg";
import newFlightMarkerOnTimeSelected from "../../../../assests/map-markers/newFlightMarkerOnTimeSelected.svg";

export const getFlightMarkerIconUrl = (
  status: string | null | undefined,
  selected: boolean
) => {
  const normalizedStatus = status?.replace(/[\s_-]/g, "").toUpperCase() ?? "";
  if (selected) {
    if (normalizedStatus === "ONTIME" || normalizedStatus === "EARLY") {
      return newFlightMarkerOnTimeSelected;
    }
    if (normalizedStatus === "DELAYED") {
      return newFlightMarkerDelayedSelected;
    }
    return newFlightMarkerDefaultSelected;
  }

  if (normalizedStatus === "ONTIME" || normalizedStatus === "EARLY") {
    return newFlightMarkerOnTime;
  }
  if (normalizedStatus === "DELAYED") {
    return newFlightMarkerDelayed;
  }
  return newFlightMarkerDefault;
};
